import cmsData from "./cmsData"
import {
  documentUploadQuery,
  documentParser,
} from "./cmsData/graphql/documentUploadPage"
import {
  downloadMonumentAppQuery,
  parseDownloadAppData,
} from "./cmsData/graphql/downloadApp"
import { headerQuery, headerParser } from "./cmsData/graphql/header"
import documentUploadMockData from "./mockData/documentUploadPage"
import axios from "axios"
import { getSessionId } from "./session"

const api_Server = process.env.REACT_APP_BTL_CALCULATOR_API_SERVER_GATEWAY_URL
const api_context = "/document-upload"
const getServer = () => {
  return location.hostname == "localhost"
    ? location.origin
    : api_Server || "https://apps.dev.mbcv2.co/frontendapi"
}

console.log("getServer" + getServer() + api_context)
const token_url = getServer() + api_context + "/api/getToken"
const documentUploadVerification =
  getServer() + api_context + "/api/document-upload-verification"
const documentTypes = getServer() + api_context + "/api/document-types"
const documentUpload = getServer() + api_context + "/api/documents"
const contentfulAPI = getServer() + api_context + "/api/content"

export async function getParsedData() {
  try {
    const header = await getData(headerQuery, headerParser)
    const headerData = {
      ...({} && { header: header }),
    }
    const bodyData = await getData(documentUploadQuery, documentParser)
    const allCMSData = { ...headerData, ...bodyData }
    return allCMSData
  } catch (error) {
    return documentUploadMockData
  }
}

/* 
Get the Download monument app Data using downloadMonumentAppQuery and using contentfulAPI.
parse the response for data using parseDownloadAppData.
*/
export async function getDownloadAppData() {
  const cmsDownloadAppData = await cmsData(
    downloadMonumentAppQuery,
    contentfulAPI
  )
  const { data } = await cmsDownloadAppData.json()
  const downloadAppData = parseDownloadAppData(data)
  return downloadAppData
}

async function getData(query, parser) {
  try {
    const response = await cmsData(query, contentfulAPI)
    const { data } = await response.json()
    const queryData = parser(data)
    return queryData
  } catch (error) {
    console.error(
      `There was a problem retrieving entries with the query ${query}`
    )
    console.error(error)
    return documentUploadMockData
  }
}

export async function getToken() {
  try {
    const response = await fetch(token_url, {
      method: "POST",
      headers: { "Content-Type": "text/plain" },
    })
    return response.json()
  } catch (err) {
    return err
  }
}

export async function getDocumentVerification(data = {}) {
  try {
    const response = await fetch(documentUploadVerification, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
    return response.json()
  } catch (error) {
    return error
  }
}

export async function getDocumentTypes() {
  try {
    const response = await fetch(documentTypes)
    return response.json()
  } catch (error) {
    return error
  }
}

export async function uploadDocument(formData, cb, index) {
  try {
    const headers = { "Content-Type": "multipart/form-data" }
    headers.Authorization = await getToken()
    const sessionId = getSessionId()
    if (sessionId) {
      headers.sessionId = sessionId
    }
    console.log("Uploading document with sessionId: " + sessionId)
    return axios({
      method: "post",
      url: documentUpload,
      data: formData,
      headers,
      onUploadProgress: function () {
        // var percentCompleted = parseInt(
        //   Math.round((progressEvent.loaded * 100) / progressEvent.total)
        // )
        cb(80, index, "")
      },
    })
  } catch (err) {
    return err
  }
}
